import { URLS } from "@/shared/utils/url/url";

const bibliography = "/bibliography";

export const NEXT_URLS = {
  home: URLS.home,
  allCollection: URLS.allCollection,
  studyCenter: URLS.studyCenter,
  subscription: URLS.subscription,
  read: URLS.read,
  bookInfo: URLS.book,
  search: URLS.textSearchResults,
  searchLocal: "/search-local",
  contactUs: URLS.contactus,
  settings: URLS.settings,
  about: URLS.about,
  searchFilters: URLS.searchFilters,
  bibliography,
  bibliographyEgw: bibliography + "?type=egw",
  bibliographyBible: bibliography + "?type=bible",
  copirightNotice: URLS.copirightNotice,
  privacyPolicy: URLS.privacyPolicy,
  userAgreement: URLS.userAgreement,
  offline: URLS.offline,

  apiAuthCallback: "/api/authCallback",
  apiGetNextPWAConfig: "/api/getPWAConfig",
  apiGetToken: "/api/getToken",
  apiRobots: "/api/robots",
  apiStatus: "/api/status",
};
